import { SelectField } from '@monorepo/shared/componentsV2/fields/SelectField';
import type { SelectOption } from '@monorepo/shared/componentsV2/Select/Select';
import type { SelectGroup } from '@monorepo/shared/componentsV2/Select/types';
import { isRequired } from '@monorepo/shared/utils/validators';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useFormTemplateContext } from '../../EditFormTemplatePage/FormTemplateContext';
import { ModalFieldWrapper } from '../styled';

const GroupSelectField = styled(SelectField)`
  display: flex;
  gap: 0.35em;
`;

const FIELD_NAME = 'groupSlug';

const UNAVAILABLE_GROUP_NAME = 'unavailable';
const selectGroups: SelectGroup[] = [
  {
    name: UNAVAILABLE_GROUP_NAME,
    label: 'Unavailable',
    tooltip: 'Repeatable sections cannot contain the inspection date.',
  },
];

export function MoveInspectionDateField() {
  const {
    formTemplate,
    formTemplateHelpers: { activeGroupSlug },
  } = useFormTemplateContext();

  const options = useMemo(
    () =>
      formTemplate?.groups
        .filter((group) => group.slug !== activeGroupSlug)
        .map((group) => {
          const groupOption: SelectOption = {
            label: group.name,
            value: group.slug,
          };
          if (group.isDuplicable) {
            groupOption.disabled = true;
            groupOption.groupName = UNAVAILABLE_GROUP_NAME;
          }
          return groupOption;
        }),
    [activeGroupSlug, formTemplate?.groups],
  );

  if (!options) return null;

  return (
    <ModalFieldWrapper>
      <GroupSelectField
        name={FIELD_NAME}
        label="Move to"
        options={options}
        groups={selectGroups}
        placeholder="Choose one"
        validate={isRequired}
      />
    </ModalFieldWrapper>
  );
}
